import { OrthographicCamera } from '@react-three/drei';
import { useEffect, useMemo, useRef, useState } from 'react';
import type * as THREE from 'three';

import type { TOOL_CONST } from '@/constant';
import { useToolSurfaceCameraStore } from '@/store';

import { useToolPcdCanvasContext } from './ToolPcdCanvas';

const ToolPcdSurfaceViewCamera = () => {
  const { initCameraOptions, viewMode } = useToolPcdCanvasContext();
  const { cameraMap } = useToolSurfaceCameraStore();
  const [far, _setFar] = useState(initCameraOptions?.far ?? 500);
  const [near, _setNear] = useState(initCameraOptions?.near ?? 10);
  const cameraRef = useRef<THREE.OrthographicCamera>(null);
  const thisCamera = useMemo(
    () =>
      cameraMap[
        viewMode as Exclude<
          Lowercase<TOOL_CONST.TOOL_CAMERA_VIEW_MODE>,
          'default'
        >
      ],
    [cameraMap, viewMode],
  );

  useEffect(() => {
    const camera = cameraRef.current;

    if (!camera?.parent) return;

    camera.zoom = thisCamera.zoom;
    camera.updateProjectionMatrix();
  }, [thisCamera]);

  return (
    <OrthographicCamera
      ref={cameraRef}
      far={far}
      near={near}
      zoom={initCameraOptions?.orthographic?.zoom}
      makeDefault={true}
    />
  );
};

export default ToolPcdSurfaceViewCamera;
